export * from './delete-abteilung.component';
export * from './delete-abteilung.component.module';